// extracted by mini-css-extract-plugin
export default {"main":"RifiutaModal_main__7ny3X","btn":"RifiutaModal_btn__WVV9h","title":"RifiutaModal_title__oMk0O","msg":"RifiutaModal_msg__Nkz-s","select":"RifiutaModal_select__HtIdC"};